import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L, ThunderDispatcher, TS_Checkbox, TS_CheckboxGroup } from '@nu-art/thunderstorm-frontend';
import { filterDuplicates, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Facility, ModuleFE_Organization } from '@app/org-frontend';
export const dispatch_OnAvatarModeFiltersChange = new ThunderDispatcher('__onAvatarModeFiltersChange');
export class Dialog_AvatarModeFilters extends ComponentSync {
    //######################### Life Cycle #########################
    __onAvatarModeFiltersChange = (selectedIds) => {
        this.setState({ selectedFacilityIds: selectedIds });
    };
    deriveStateFromProps(nextProps, state) {
        state.encounters = nextProps.encounters;
        state.selectedFacilityIds ??= nextProps.selectedFacilityIds;
        state.managedEncounterOnly = nextProps.activeEncountersOnly ?? false;
        return state;
    }
    //######################### Logic #########################
    getOrganizationToFacilitiesMap = () => {
        const encountersWithFacilities = this.state.encounters.filter(encounter => encounter.facilityId);
        const facilities = filterDuplicates(encountersWithFacilities.reduce((acc, encounter) => {
            const facility = ModuleFE_Facility.cache.unique(encounter.facilityId);
            if (!facility) {
                this.logError(`Facility ${encounter.facilityId} was not found.`);
                return acc;
            }
            acc.push(facility);
            return acc;
        }, []), facility => facility._id);
        const organizationIds = filterDuplicates(facilities.map(facility => facility.organizationId));
        const organizations = filterDuplicates(organizationIds).map(orgId => {
            const organization = ModuleFE_Organization.cache.unique(orgId);
            if (!organization)
                throw new MUSTNeverHappenException(`Organization id ${orgId} was not found.`);
            return organization;
        });
        return organizations.reduce((acc, organization) => {
            const orgFacilities = facilities.filter(facility => facility.organizationId === organization._id);
            acc.push({ facilities: orgFacilities, organization });
            return acc;
        }, []);
    };
    handleSelectionChange = (selectedIds, idScope) => {
        let idsToDispatch = this.state.selectedFacilityIds.filter(facilityId => {
            if (!idScope.includes(facilityId))
                return true;
            return selectedIds.includes(facilityId);
        });
        idsToDispatch = filterDuplicates([...idsToDispatch, ...selectedIds]);
        dispatch_OnAvatarModeFiltersChange.dispatchUI(idsToDispatch);
    };
    onResetFilters = () => {
        const facilityIds = filterDuplicates(this.state.encounters.map(encounter => {
            return encounter.facilityId;
        }));
        dispatch_OnAvatarModeFiltersChange.dispatchUI(facilityIds);
        this.setState({ managedEncounterOnly: false });
        this.props.onActiveEncountersChange(false);
    };
    //######################### Render #########################
    render() {
        const options = this.getOrganizationToFacilitiesMap();
        return (_jsxs(LL_V_L, { children: [_jsx("div", { className: 'avatar-mode__filters__title', children: "Filters" }), _jsx(TS_Checkbox, { checked: this.state.managedEncounterOnly, onCheck: (checked) => {
                        this.setState({ managedEncounterOnly: checked });
                        this.props.onActiveEncountersChange(checked);
                    }, className: 'avatar-mode__filters__managed-checkbox', children: "Active Encounters" }), _jsx("div", { className: 'avatar-mode__filters__separator' }), _jsx("div", { className: 'avatar-mode__filters__title', children: "Facilities" }), options.map(option => {
                    const parent = { id: option.organization._id, label: option.organization.name };
                    const children = option.facilities.map(facility => ({ id: facility._id, label: facility.name }));
                    const idScope = children.map(child => child.id);
                    const selectedOptionsForOrganization = (option.facilities.filter(facility => this.state.selectedFacilityIds.includes(facility._id)))
                        .map(facility => facility._id);
                    return (_jsx(TS_CheckboxGroup, { parent: parent, options: children, selectedIds: selectedOptionsForOrganization, onChange: selectedIds => this.handleSelectionChange(selectedIds, idScope) }, parent.id));
                }), _jsx(Button, { onClick: () => this.onResetFilters(), children: "Reset Filters" })] }));
    }
}
//# sourceMappingURL=Dialog_AvatarModeFilters.js.map